module.exports = __webpack_public_path__ + "static/img/matter_lun1.bee2352.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/matter/matter_lun1.jpg
// module id = vHSL
// module chunks = 1